module.exports = __webpack_public_path__ + "img/schild.0b886e6e.png";